/**
  General purpose oo tools for [e] namespace
*/
module.exports = {
  /* 
    Interface that provides a basic event type callback 
    function for object paramaters added to a class 
    that implements this tool.

    @see JavaScript Cookbook 16.4
    @example implementation in a class:
      // add to the head
      self.callback = npm.Tools.callback; // implements

      // within a function
      self.callback('resize', [event]);

      // in new object options
      onResize: function() { callback code } 

  */
  callback: function(name, args) {
    // Maps 'onCallback' option to 'callback' function
    var callbackName = 'on' + name.charAt(0).toUpperCase() + name.slice(1);
    if (typeof this.options[callbackName] == 'function') {
      this.options[callbackName].apply(this, args); 
    }
  },

  /*
    Merges local param with self.param 
    local recieves the new params
    @example
      self.options = self.mergeParams(self.options, options);
  */
  mergeParams: function(local, param) {
    return $.extend(true, local, param);

  },

  /*
    Recursively merges the parameter object to a the history
    state cookie object without erasing the existing data

    @requires jQuery.cookie
    @example 
  */
  extendCookie: function(obj) {
    var cookie = JSON.parse($.cookie(e.config.cookieKey)) || {};
    cookie = this.mergeParams(cookie, obj);
    $.cookie(e.config.cookieKey, JSON.stringify(cookie), { path: '/', expires: 365 });
  },

  /*
    Returns the history state cookie
  */
  getCookie: function() {
    return JSON.parse($.cookie(e.config.cookieKey)) || {};
  },

  /* 
    Window location history
    
    Replace current url with options merged in
      options [obj] paramaters to add to the url 
      callback [fn] (optional) function to modify the parameters before set
  */
  historyReplace: function(options, callback) {
    if (window.history.replaceState) {
      var url = this.historyMerge(options, callback);
      window.history.replaceState(options, '', url);
    }
  },

  /*
    Add new url to history with options merged in
      options [obj] paramaters to add to the url 
      callback [fn] (optional) function to modify the parameters before set
  */
  historyPush: function(options, callback) {
    if (window.history.pushState) {
      var url = this.historyMerge(options, callback);
      window.history.pushState(options, '', url);
    }
  },

  /*
    Merge param options into url string
      options [obj] paramaters to add to the url 
      callback [fn] (optional) function to modify the parameters before set
  */
  historyMerge: function(options, callback) {
    var params = this.getParams();
    this.mergeParams(params, options);
    for (var key in params) {
      if (params[key] === '') delete params[key];
    }
    if (typeof callback == 'function') callback(params);
    return this.getUrlString(params);
  },

  /*
    Clears the search and hash url params
  */
  clearParams: function() {
    window.history.replaceState({}, '', window.location.pathname);
  },

  /* 
    Convert obj -> url GET string 
  */
  serialize: function(obj) {
    return $.param(obj);
  },

  /* 
    Convert url GET string -> object 
  */
  unserialize: function(string) {
    var pair, obj = {};
    string = string.split('&');
    $.each(string, function(index, value) {
      pair = value.split('=');
      if (pair[0]) obj[pair[0]] = decodeURIComponent(pair[1]);
    });
    return obj;
  },

  /* 
    Gets the current window url params as an object 
  */
  getParams: function() {
    return this.unserialize(window.location.search.substr(1));
  },

  /*
    Returns a url string based on a paramaters object
  */
  getUrlString: function(params) {
    return window.location.pathname + '?' + this.serialize(params) + window.location.hash;
  },

  /* sets a new url param from an object keeping all current params */
  setParams: function(params) {
    window.location = this.historyMerge(params);
  },

  /*
    Poor man's implementation of the Rails to_sentance method
  */
  toSentance: function(array, and) {
    var end = array.pop();
    return array.join(', ') + ', ' + and + end;
  },

  htmlEscape: function(string) {
    return String(string)
      .replace(/&/g, '&amp;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  },

  htmlUnescape: function(coded){
    return String(coded)
      .replace(/&quot;/g, '"')
      .replace(/&#39;/g, "'")
      .replace(/&lt;/g, '<')
      .replace(/&gt;/g, '>')
      .replace(/&amp;/g, '&');
  }

};

